import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { memo } from 'react';
import AddPhotoIcon from './components/AddPhotoIcon';
import FileList from './components/FileList';
import OpenCameraIcon from './components/OpenCameraIcon';
import UploadIcon from './components/UploadIcon';
import { useCaptureManagerState } from './context';
import { CaptureManagerState } from './context/type';

const CaptureManager = ({
  modal,
  onSelect,
}: {
  modal: Omit<ModalStaticFunctions, 'warn'>;
  onSelect: (val: CaptureManagerState['selected']) => void | undefined;
}) => {
  const { appearance, importRef } = useCaptureManagerState();

  return (
    <>
      <div className="flex flex-wrap items-baseline justify-center space-x-2 space-y-2">
        <OpenCameraIcon />
        {/* <DeleteIcon importRef={importRef} /> */}
        <AddPhotoIcon importRef={importRef} modal={modal} />
        {appearance !== 'hide-camera' && <UploadIcon />}
      </div>
      <FileList modal={modal} onSelect={onSelect} />
    </>
  );
};

export default memo(CaptureManager);
